<template>
  <v-container fluid style="height: calc(100vh - 64px)">
    <v-row style="height:100%">
      <v-col cols="12" md="6" class="pt-0" style="height: 100%">
        <v-card ref="content" height="100%">
          <v-row style="height:55px; margin-bottom: 10px;" no-gutters>
            <v-col class="pa-3" cols="6">
              <span class="headline">{{getTitle()}}</span>
            </v-col>
            <v-col class="pa-3" cols="6">
              <v-btn
                class="float-right mr-1"
                fab
                dark
                small
                color="primary"
                v-if="isCBRE"
                :title="$i18n.t(`dashboard.table.copyCbre`)"
                @click="copyCbreDialog()"
              >
                <v-icon dark>mdi-content-copy</v-icon>
              </v-btn>
              <v-btn
                class="float-right mr-1"
                fab
                dark
                small
                color="primary"
                v-if="!isCBRE"
                @click="copyPublicOffer()"
                :title="$i18n.t(`dashboard.table.copy`)"
              >
                <v-icon dark>mdi-content-copy</v-icon>
              </v-btn>
              <v-btn
                class="float-right mr-1"
                fab
                dark
                small
                color="primary"
                v-if="isCBRE"
                @click="editOffer()"
                :title="$i18n.t(`default.saveEditing`)"
              >
                <v-icon dark>mdi-content-save-outline</v-icon>
              </v-btn>
              <v-btn
                class="float-right mr-1"
                fab
                dark
                small
                color="primary"
                @click="$router.push('/dashboard');"
                :title="$i18n.t(`dashboard.backToOffers`)"
              >
                <v-icon dark>mdi-arrow-left</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters class="attributes" v-if="isReady">
            <v-col>
              <div style v-bar>
                <v-expansion-panels accordion>
                  <v-expansion-panel v-for="(category, idx) in Object.keys(attributes)" :key="idx">
                    <v-expansion-panel-header>{{ $i18n.t(`offer.categories.${category}`) }}</v-expansion-panel-header>
                    <v-expansion-panel-content class="pt-1">
                      <v-form ref="form">
                        <template v-for="(attribute, idx2) of attributes[category]">
                          <component
                            v-if="fieldComponent(attribute)"
                            :is="fieldComponent(attribute)"
                            :key="idx2"
                            :attribute="attribute"
                            :canEdit="canEdit"
                            :isCopied="isCopied(attribute.name)"
                            v-model="attribute.value"
                          />
                          <v-row v-else :key="idx2">
                            <v-col v-if="attribute.name !== 'cena_m'" cols="4" class="pa-0 pr-1">
                              <v-subheader style="height: auto; min-height: 48px;">
                                <span>
                                  {{
                                  attribute[`label_${$i18n.locale}`] ||
                                  'No translation'
                                  }}
                                  <template
                                    v-if="attribute.measure_unit && attribute.name !== 'cena_pum'"
                                  >
                                    <span class="caption" v-html="attribute.measure_unit" />
                                  </template>
                                </span>
                              </v-subheader>
                            </v-col>
                            <v-spacer v-if="attribute.name === 'cena_m'"></v-spacer>
                            <v-col v-if="attribute.type === 'computed'" cols="8" class="py-0">
                              <computed-row
                                :attribute="attribute"
                                :label-cols="0"
                                :value-cols="12"
                                :values="flatProperties"
                                v-model="attribute.value"
                              />
                            </v-col>
                            <v-col v-if="attribute.type === 'disabled'" cols="8" class="pa-0">
                              <v-text-field
                                v-model="attribute.value"
                                disabled
                                :readonly="!isCBRE"
                                outlined
                              />
                            </v-col>
                            <v-col v-if="attribute.type === 'boolean'" cols="8" class="pa-0">
                              <v-select
                                :attach="true"
                                :readonly="!canEdit"
                                v-model="attribute.value"
                                :items="dicts.boolean"
                                :item-text="$i18n.locale"
                                item-value="bool"
                                outlined
                              />
                            </v-col>
                            <v-col v-if="attribute.type == 'price'" cols="8" class="pa-0">
                              <price-field
                                v-if="attribute.name === 'cena_zakupu'"
                                v-model="attribute.value"
                                :label="$i18n.t('default.pln')"
                                :outlined="true"
                                :readonly="!canEdit"
                              />
                              <v-text-field
                                v-if="attribute.name === 'cena_zakupu'"
                                readonly
                                :disabled="isCopied(attribute.name)"
                                outlined
                                v-model.number="priceEur"
                                :label="$i18n.t('default.eur')"
                                type="text"
                              />
                              <price-field
                                v-if="attribute.name === 'cena_m'"
                                v-model="pricePLNM"
                                :label="$i18n.t('default.plnm2')"
                                :outlined="true"
                                :readonly="!canEdit"
                              />
                              <v-text-field
                                v-if="attribute.name === 'cena_m'"
                                readonly
                                :disabled="isCopied(attribute.name)"
                                outlined
                                v-model.number="priceEurM"
                                :label="$i18n.t('default.eurm2')"
                                type="text"
                              />
                            </v-col>
                            <Multiselect
                              v-if="attribute.type === 'multiselect'"
                              :attribute="attribute"
                              :canEdit="canEdit"
                              :isCopied="isCopied(attribute.name)"
                              :dicts="dicts"
                            />
                            <KwNumberFieldOffer
                              v-if="attribute.type === 'nr_kw'"
                              :attribute="attribute"
                              :canEdit="canEdit"
                              :isCopied="isCopied(attribute.name)"
                            />
                            <SoilClass
                              v-if="attribute.type === 'kvp'"
                              :canEdit="canEdit"
                              v-model="attribute.value"
                            ></SoilClass>
                            <PumField
                              v-if="attribute.type === 'pum'"
                              :canEdit="canEdit"
                              v-model="attribute.value"
                            />
                            <v-col v-if="attribute.type == 'select'" cols="8" class="pa-0">
                              <v-select
                                :attach="true"
                                v-if="attribute.name == 'wojewodztwo'"
                                v-model="attribute.value"
                                :items="provinces"
                                :disabled="!canEdit"
                                item-text="jpt_nazwa_"
                                item-value="jpt_nazwa_"
                                @change="changedWojewodztwo()"
                                outlined
                              />
                              <v-select
                                :attach="true"
                                v-else-if="attribute.name == 'powiat'"
                                :disabled="!canEdit"
                                v-model="attribute.value"
                                :items="counties"
                                item-text="jpt_nazwa_"
                                item-value="jpt_nazwa_"
                                @change="changedPowiat()"
                                outlined
                              />
                              <v-select
                                :attach="true"
                                v-else-if="attribute.name == 'gmina'"
                                :disabled="!canEdit"
                                v-model="attribute.value"
                                :items="
                                  getProperty(isCBRE ? 'localization' : 'public_data', 'powiat').value
                                    ? communes
                                    : []
                                "
                                item-text="jpt_nazwa_"
                                item-value="jpt_nazwa_"
                                outlined
                              />
                            </v-col>
                          </v-row>
                        </template>
                      </v-form>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" class="pt-0" style="height: 100%">
        <v-row style="height: 50%">
          <v-col cols="12" style="height:100%" class="pt-0">
            <v-card height="100%">
              <v-row no-gutters style="height: 100%">
                <v-col class="pa-1" style="height:100%">
                  <div style="height:100%;width:100%">
                    <DashboardMap
                      ref="map"
                      :single-offer="true"
                      :has-filter="false"
                      :offers="isNewEntity ? [newOffer] : [selectedOffer]"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-row style="height:50%" class="parcels" ref="parcels">
          <v-col cols="12" style="height:100%" class="pb-0">
            <v-card height="100%">
              <v-row style="height:65px" no-gutters>
                <v-col class="pa-3" cols="10">
                  <v-tabs v-model="activeTab" ref="tabs_1">
                    <v-tab>{{ $i18n.t(`offer.parcels.title`) }}</v-tab>
                    <v-tab>{{ $i18n.t(`offer.categories.comments`) }}</v-tab>
                    <v-tab>{{ $i18n.t(`offer.categories.attachments`) }}</v-tab>
                  </v-tabs>
                  <v-btn
                    class="btn--add"
                    fab
                    dark
                    small
                    v-show="activeTab !== 0"
                    color="primary"
                    :title="activeTab === 1 ? $i18n.t('offer.comments.addComment'): $i18n.t('offer.attachments.upload')"
                    @click="addTableElement"
                  >
                    <v-icon dark>mdi-plus</v-icon>
                  </v-btn>
                  <v-btn
                    class="btn--phone"
                    fab
                    dark
                    small
                    v-show="activeTab === 1"
                    color="primary"
                    :title="lastContactTitle"
                    @click="addLastContact"
                  >
                    <v-icon dark>mdi-cellphone-android</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="2 pa-3">
                  <v-btn
                    class="float-right"
                    fab
                    v-show="activeTab === 0"
                    dark
                    :title="$i18n.t('dashboard.map.addParcel')"
                    small
                    color="primary"
                    @click="showDefaultDialog"
                  >
                    <v-icon dark>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row style="height: calc(100% - 65px); margin-top: 5px;" no-gutters>
                <v-col class="pa-1" style="height:100%">
                  <div style="height:100%;width:100%" v-show="activeTab === 0">
                    <CustomDataTable
                      :items="parcels"
                      :headers="parcelsHeaders"
                      entity-type="offer.parcels"
                      :disable-pagination="true"
                    >
                      <template v-slot:tools="{ item }">
                        <v-icon
                          small
                          @click="$refs.map.zoomToGeometry(item.geometry, 3857, 4326)"
                          :title="$i18n.t('offer.parcels.table.zoomIn')"
                        >mdi-magnify-plus-outline</v-icon>
                        <v-icon
                          small
                          icon
                          :title="$i18n.t('parcels.table.details')"
                          @click="$router.push(`/parcels/${item.id}`)"
                        >mdi-eye-outline</v-icon>
                        <span
                          :title="
                            $i18n.t(`offer.parcels.table.${parcels.length > 1 ? 'delete' : 'oneParcelIsRequired'}`)
                          "
                        >
                          <v-icon small :disabled="parcels.length < 2" @click="deleteParcelFromOffer(item)">
                            mdi-delete
                          </v-icon >
                        </span>
                      </template>
                    </CustomDataTable>
                  </div>
                  <div style="height:100%;width:100%" v-show="activeTab === 1">
                    <CommentsTable
                      v-if="isParcelsFetched"
                      ref="commentsTable"
                      :entity-id="entityID"
                      entity-type="offer"
                      :entities="parcels"
                    />
                  </div>
                  <div style="height:100%;width:100%" v-show="activeTab === 2">
                    <AttachmentsTable
                      v-if="isParcelsFetched"
                      ref="attachmentsTable"
                      :entity-id="entityID"
                      entity-type="offer"
                      :entities="parcels"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <ConfirmDialog
      v-if="confirmDialogLoaded"
      :dialog="confirmDialogVisible"
      @success="confirmDelete()"
      @cancel="confirmDialogVisible = false"
    >
      <template v-slot:header>
        <h1>{{ $i18n.t(`offer.${deleteFrom}.deleteHeader`) }}</h1>
      </template>
      <template v-slot:content>
        <p>{{ $i18n.t(`offer.${deleteFrom}.deleteBody`) }}</p>
      </template>
    </ConfirmDialog>
    <ConfirmDialog
      :dialog="isConfirmExitVisible"
      @success="confirmExit"
      @cancel="isConfirmExitVisible = false"
    >
      <template v-slot:header>
        <h1>{{ $i18n.t(`default.confirmExitHeader`) }}</h1>
      </template>
      <template v-slot:content>
        <p>{{ $i18n.t(`default.confirmExitBody`) }}</p>
      </template>
    </ConfirmDialog>
    <DefaultDialog
      :dialog="isDefaultDialogVisible"
      v-if="isDefaultDialogLoaded"
      @cancel="isDefaultDialogVisible = false; $refs.wojPowGmiFilter.woj = undefined"
      max-width="80%"
    >
      <template v-slot:header>
        <div class=" headline" style="font-weight: 500">{{$i18n.t('dashboard.map.addParcel')}}</div>
      </template>
      <template v-slot:content>
        <SelectFilterWojPowGmi ref="wojPowGmiFilter" @wpg="wpg=$event" />
        <CustomDataTable
          :items="parcelsOutOfOffer"
          :headers="parcelsHeaders"
          entity-type="offer.parcels"
        >
          <template v-slot:tools="{ item }">
            <v-icon
              small
              icon
              :title="$i18n.t('parcels.table.addToOffer')"
              @click="addParcelToOffer(item)"
            >mdi-plus</v-icon>
            <v-icon
              small
              icon
              :title="$i18n.t('parcels.table.details')"
              @click="$router.push(`/parcels/${item.id}`)"
            >mdi-eye-outline</v-icon>
          </template>
        </CustomDataTable>
      </template>
    </DefaultDialog>
    <ConfirmDialog
      v-if="copyCbreDialogLoaded"
      :dialog="copyCbreDialogVisible"
      @success="copyCbre()"
      @cancel="copyCbreDialogVisible = false"
    >
      <template v-slot:header>
        <h1>{{ $i18n.t(`dashboard.copyDialog.title`) }}</h1>
      </template>
      <template v-slot:content>
        <p>{{ $i18n.t(`dashboard.copyDialog.contentQuestion`) }}</p>
      </template>
    </ConfirmDialog>
  </v-container>
</template>

<script>
import axios from 'axios';
import { setTimeout } from 'timers';

import DashboardMap from '@/components/dashboard/DashboardMap';
import CustomDataTable from '@/components/CustomDataTable';
import AttachmentsTable from '@/components/AttachmentsTable';
import CommentsTable from '@/components/CommentsTable';
import Multiselect from '@/components/Multiselect';
import SelectFilterWojPowGmi from '@/components/SelectFilterWojPowGmi';
import KwNumberFieldOffer from '@/components/KwNumberFieldOffer';
import SoilClass from '@/components/SoilClass';
import PriceField from '@/components/fields/PriceField';
import ComputedRow from '@/components/fields/ComputedRow';

import { getFieldComponent } from '@/components/fields/fieldComponents';

import { DICTS } from '@/dicts';
import { wojOptions } from '@/models/Offer';

//mixins
import entityBasicMixin from '@/mixins/entityBasicMixin';
import pricesMixin from '@/mixins/pricesMixin';
import prgMixin from '@/mixins/prgMixin';
import tabsMixin from '@/mixins/tabsMixin';

const TYPE = function(obj) {
  return {}.toString
    .call(obj)
    .match(/\s([a-zA-Z]+)/)[1]
    .toLowerCase();
};

export default {
  mixins: [entityBasicMixin, pricesMixin, prgMixin, tabsMixin],
  components: {
    DashboardMap,
    CustomDataTable,
    AttachmentsTable,
    CommentsTable,
    Multiselect,
    KwNumberFieldOffer,
    SoilClass,
    PriceField,
    PumField: () => import('@/components/fields/PumField'),
    ConfirmDialog: () => import('@/components/ConfirmDialog'),
    DefaultDialog: () => import('@/components/DefaultDialog'),
    SelectFilterWojPowGmi,
    ComputedRow

    // AddCommentAttachment: () => import('@/components/AddCommentAttachment')
  },
  data: () => ({
    attributes: undefined,
    copiedAttributes: [
      // 'nr_ew_dzialek',
      // 'nr_obre',
      // 'pow_dzialki',
      // 'wymiary_dzialki',
      // 'rodzaj_zgloszenia',
      // 'rodzaj_nieruchomosci',
      // 'rodzaj_umowy_posr',
      // 'linia_biznesowa_cbre',
      // 'kontakt_cbre',
      // 'nr_ew_dzialek',
      // 'nr_obre',
      // 'nr_kw',
      // 'pow_dzialki',
      // 'pow_kl_bonitacyjna',
      // 'wlasnosc',
      // '__wlasciciele',
      // 'procedura_nabycia',
      // 'cena_zakupu',
      // 'cena_m',
      // 'szacowany_czas_zakupu'
    ],
    isEditableOffer: true,
    filters: [],

    attachments: [],

    comments: [],
    commentsHeaders: [
      {
        text: 'content',
        value: 'content',
        type: 'text'
      },
      {
        text: 'created_at',
        value: 'created_at',
        type: 'date'
      },
      {
        text: 'created_by',
        type: 'text',
        value: 'created_by'
      },
      {
        text: 'tools',
        value: 'tools',
        align: 'center',
        sortable: false
      }
    ],
    copyCbreDialogLoaded: false,
    copyCbreDialogVisible: false,
    canEdit: false,
    deleteFrom: undefined,
    selectedItemIndex: undefined,
    addingElement: undefined,

    activeTab: 0,

    zoom: undefined,
    center: undefined,
    offers: [],
    isCBRE: false,

    isReady: false,
    selectedOffer: undefined,

    // components settings
    isDefaultDialogLoaded: false,
    isDefaultDialogVisible: false,
    confirmDialogLoaded: false,
    confirmDialogVisible: false,
    isCommentAttachmentModal: false,
    isLegendActive: false,

    parcelsHeaders: [
      {
        text: 'powierzchnia',
        value: 'powierzchnia',
        type: 'number'
      },
      {
        text: 'wojewodztwo',
        value: 'wojewodztwo',
        type: 'text',
        translate: false
      },
      {
        text: 'powiat',
        value: 'powiat',
        type: 'text',
        translate: false
      },
      {
        text: 'gmina',
        value: 'gmina',
        type: 'text',
        translate: false
      },
      {
        text: 'nr_ew_dzialek',
        value: 'nr_ew_dzialek',
        type: 'text',
        translate: false
      },
      {
        text: 'nr_obre',
        value: 'nr_obre',
        type: 'text',
        translate: false
      }
    ],
    parcels: [],
    allParcels: [],

    valuationClasses: ['I', 'II', 'IIIa', 'IIIb', 'IVa', 'IVb', 'V', 'VI', 'VIz'],
    emptyValuationClasses: [],
    I: '',
    II: '',
    IIIa: '',
    IIIb: '',
    IVa: '',
    IVb: '',
    V: '',
    VI: '',
    VIz: '',
    selectedValuationClass: undefined,
    wpg: {
      woj: undefined,
      pow: undefined,
      gmi: undefined
    },
    isParcelsFetched: false,
    confirmExitTo: undefined,
    isConfirmExitVisible: false,
    isEdited: false
  }),
  computed: {
    wojOptions() {
      return [{ value: '', name: this.$i18n.t('dashboard.offers.all') }].concat(wojOptions);
    },
    rules() {
      return {
        number: v => /([0-9]+([.][0-9]+)?)/.test(v) || this.$i18n.t('default.mustBeNumber'),
        numberInt: v => /[0-9]/.test(v) || this.$i18n.t('default.mustBeInt')
      };
    },
    parcelsFiltered() {
      return this.allParcels.filter(offer => {
        if (this.wpg.woj && offer.wojewodztwo !== this.wpg.woj.jpt_nazwa_) {
          return false;
        }
        if (this.wpg.pow && offer.powiat !== this.wpg.pow.jpt_nazwa_) {
          return false;
        }
        if (this.wpg.gmi && offer.gmina !== this.wpg.gmi.jpt_nazwa_) {
          return false;
        }
        return true;
      });
    },
    parcelsOutOfOffer() {
      return this.parcelsFiltered.filter(parcel => !this.parcels.some(offerParcel => offerParcel.id === parcel.id));
    },
    mapZoom() {
      return this.$store.getters.getZoom;
    },
    mapCenter() {
      return this.$store.getters.getCenter;
    },
    flatProperties() {
      const flatProperties = {};
      for (let group in this.attributes) {
        this.attributes[group].forEach(property => {
          flatProperties[property.name] = property;
        });
      }
      return flatProperties;
    },
    lastContactTitle() {
      const date = new Date().toLocaleString('pl-PL', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
      return this.$i18n.t('offer.comments.addLastContact') + ': ' + date;
    }
  },
  methods: {
    init() {
      if (this.entityID === 'new') {
        if (this.$store.getters.getNewOffer == undefined) {
          this.$router.push('/dashboard');
          return;
        }
        this.newOffer = this.$store.getters.getNewOffer;
        this.$store.dispatch('getOffer', { id: 'schema' }).then(r => {
          if (r.status === 200) {
            this.attributes = r.data.data;
            this.canEdit = true;
            this.isCBRE = true;
            this.$refs.map.zoomToGeometry(this.newOffer.geometry);
            for (let group in this.attributes) {
              for (let i = 0; i < this.attributes[group].length; i++) {
                if (this.attributes[group][i].translate && this.attributes[group][i].type !== 'multiselect') {
                  this.$set(this.attributes[group][i], 'value', {
                    pl: null,
                    en: null
                  });
                } else {
                  this.$set(this.attributes[group][i], 'value', null);
                }
              }
            }
            this.isReady = true;
          }
        });
      } else {
        this.$store
          .dispatch('getOffer', {
            id: this.entityID
          })
          .then(r => {
            if (r.status === 200) {
              this.attributes = r.data.offers;
              this.getPRG('communes');
              this.getPRG('counties');
              //@TODO temporary fix - null to object with en, pl properties
              for (let group in this.attributes) {
                for (let i = 0; i < this.attributes[group].length; i++) {
                  if (
                    (this.attributes[group][i].translate || this.attributes[group][i].type == 'select') &&
                    this.attributes[group][i].value === null
                  ) {
                    this.$set(this.attributes[group][i], 'value', {
                      pl: null,
                      en: null
                    });
                  }
                }
              }
              this.keeper = this.attributes.keeper;
              delete this.attributes.keeper;
              const geometria = this.attributes.geometria;
              delete this.attributes.geometria;
              this.selectedOffer = {
                ...geometria,
                id: this.entityID
              };
              for (const flatProperty in this.flatProperties) {
                this.selectedOffer[flatProperty] = this.flatProperties[flatProperty].value;
              }
              this.$refs.map.zoomToGeometry(this.selectedOffer.geometry, 3857, 4326);
              this.canEdit = this.keeper === 'CBRE';
              this.isCBRE = this.keeper === 'CBRE';
              this.isReady = true;
              this.recalculatePrices();
              this.attributesCopy = JSON.parse(JSON.stringify(this.flatProperties));
            }
          })
          .catch(e => {
            console.error(e);
            this.$root.$emit('showSnackbar', e);
            this.$router.push('/dashboard');
          });
        this.$store
          .dispatch('getOfferParcels', { offer: this.entityID })
          .then(data => {
            this.parcels = data;
            this.isParcelsFetched = true;
            if (data > 0) {
              setTimeout(() => {
                this.$refs.map.zoomToExtent(
                  this.$refs.map
                    .getLayerByName('offers')
                    .getSource()
                    .getExtent()
                );
              }, 0);
            }
            return this.$store.dispatch('getParcels');
          })
          .then(data => {
            this.allParcels = data;
          });
      }
    },
    addLastContact() {
      this.$root.$emit('addLastContactComment');
    },
    fieldComponent(attribute) {
      if (attribute.name === 'wojewodztwo') {
        return false;
      }
      if (attribute.name === 'powiat') {
        return false;
      }
      if (attribute.name === 'gmina') {
        return false;
      }
      return getFieldComponent(attribute);
    },
    addTableElement() {
      if (this.activeTab === 1) {
        this.$root.$emit('openCommentsDialog');
      } else {
        this.$root.$emit('openAttachmentsDialog');
      }
    },
    addNewOffer() {
      for (let key in this.attributes) {
        this.attributes[key].forEach(attr => {
          attr.value = '';
        });
      }
    },
    addParcelToOffer(parcel) {
      axios({
        method: 'post',
        url: '/parcels_offers',
        params: {
          parcel: parcel.id,
          offer: this.entityID
        }
      })
        .then(r => {
          if (r) {
            this.parcels.push(parcel);
            this.$root.$emit('showSnackbar', this.$i18n.t('offer.offers.parcelAddedSuccessfully'));
            this.parcelsListChanged();
          }
          return false;
        })
        .catch(e => {
          console.error(e);
          this.$root.$emit('showSnackbar', e);
        });
    },
    closeCommAttachModal() {
      this.isCommentAttachmentModal = false;
    },
    confirmDelete() {
      this[this.deleteFrom][this.deleteFrom].splice(this.selectedItemIndex, 1);
      this.confirmDialogVisible = false;
    },
    updateProperty(group, name, value) {
      const attribute = this.attributes[group].find(attr => attr.name === name);
      if (attribute) {
        attribute.value = value;
      }
    },
    copyPublicOffer() {
      this.$store.dispatch('postPublicOfferToCopy', this.entityID).then(r => {
        if (r.status === 200 || r.status === 201) {
          this.$root.$emit('showSnackbar', this.$i18n.t('offer.offers.copy200'));
          this.canEdit = true;
          this.isCBRE = true;
          this.$router.push({
            name: 'offer',
            params: { id: r.data.offers }
          });
        } else {
          this.$root.$emit('showSnackbar', this.$i18n.t('offer.offers.errorDB'));
        }
      });
    },
    copyCbre() {
      this.copyCbreDialogVisible = false;
      this.$store.dispatch('copyCbre', this.entityID).then(r => {
        this.$router.push({ name: 'offer', params: { id: r.data.offers } });
        this.copyCbreDoneDialogLoaded = true;
        this.copyCbreDoneDialogVisible = true;
      });
    },
    copyCbreDialog() {
      this.copyCbreDialogLoaded = true;
      this.copyCbreDialogVisible = true;
    },
    deleteParcelFromOffer(parcel) {
      const idx = this.parcels.indexOf(parcel);
      const data = {
        parcel: parcel.id,
        offer: this.selectedOffer.id
      };
      this.$store.dispatch('deleteParcelFromOffer', data).then(r => {
        if (r.status === 200 || r.status === 201) {
          this.parcels.splice(idx, 1);
          this.$root.$emit('showSnackbar', this.$i18n.t('parcels.deletedParcelFromOffer'));
          this.parcelsListChanged();
        } else {
          this.$root.$emit('showSnackbar', this.$i18n.t('offer.offers.errorDB'));
        }
      });
    },
    getTitle() {
      if (this.isCBRE || (!this.keeper && this.keeper !== 'CBRE')) {
        return `${this.$i18n.t('offer.attributes.title')}`;
      } else {
        return `${this.$i18n.t('offer.attributes.title')} (${this.$i18n.t('offer.attributes.obtainedFrom')} ${
          this.keeper
        })`;
      }
    },
    parcelsListChanged() {
      this.init();
      this.recalculateArea();
      this.$refs.attachmentsTable.getAttachments();
      this.$refs.commentsTable.getComments();
    },
    recalculateArea() {
      const area = this.getProperty(this.isCBRE ? 'site_description' : 'public_data', 'pow_dzialki');
      const value = this.parcels.reduce((total, parcel) => total + parcel.powierzchnia, 0);
      area.value = value;
    },
    deleteRow(table, idx) {
      this.confirmDialogLoaded = true;
      this.confirmDialogVisible = true;
      this.deleteFrom = table;
      this.selectedItemIndex = idx;
    },
    downloadAttachment(id) {
      this.$store.dispatch('downloadAttachment', id).then(r => {
        if (r.status === 200) {
          const blob = new Blob([r.data], { type: r.data.type });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = r.headers.attachment_filename; //<--- Brakuje nazwy pliku, request go nie zwraca. Plik się pobiera ale ma nazwę undefined.
          link.click();
        } else {
          this.$root.$emit('showSnackbar', this.$i18n.t('offer.offers.errorDB'));
        }
      });
    },
    editComment() {},
    getProperty(group, name) {
      const property = this.attributes[group].find(attr => attr.name === name);
      return property;
    },
    isCopied(name) {
      const value = this.attributesCopy[name].value;
      if (this.isEmpty(value)) {
        return false;
      }
      return this.copiedAttributes.includes(name);
    },
    isEmpty(value) {
      if (!value) {
        return true;
      } else if (Object.keys(value).length === 0 && value.constructor === Object) {
        return true;
      } else if (Array.isArray(value)) {
        if (value.length === 0) {
          return true;
        }
        if (value.length === 1) {
          if (value[0].pl === null && value[0].en === null) {
            return true;
          }
        }
      } else if ((value.pl === null) & (value.en === null)) {
        return true;
      }
      return false;
    },
    setValue(value) {
      this.$emit('input', Number(value));
    },
    isInt(e) {
      const char = String.fromCharCode(e.keyCode);
      if (!/[0-9]/.test(char)) {
        e.preventDefault();
      }
    },
    saveEditing(table, idx) {
      let payload = this[table][table][idx];
      this.$store.dispatch(`${table}Edit`, payload).then(r => {
        if (r.status === 200) {
          // console.log(r)
        }
      });
    },
    showDefaultDialog() {
      if (this.parcelsOutOfOffer.length) {
        this.isDefaultDialogLoaded = true;
        this.isDefaultDialogVisible = true;
      } else {
        this.$root.$emit('showSnackbar', this.$i18n.t('offers.offerIncludesAllParcels'));
      }
    },
    postNewOffer() {
      if (this.getIsFormValid()) {
        this.$store.dispatch('postNewOffer', this.preparePayload()).then(r => {
          if (r.status === 201) {
            this.$router.push({
              name: 'offer',
              params: {
                id: r.data.offers
              }
            });
            this.$root.$emit('showSnackbar', this.$i18n.t('offer.offers.save201'));
          } else {
            this.$root.$emit('showSnackbar', this.$i18n.t('offer.offers.errorDB'));
          }
        });
      } else {
        this.$root.$emit('showSnackbar', this.$i18n.t('default.formErrors'));
      }
    },
    getIsFormValid() {
      return (this.$refs.form || []).every(form => {
        return form.validate();
      });
    },
    preparePayload() {
      let payload = {};
      this.flatProperties.cena_m.value = this.pricePLNM;
      if (Array.isArray(this.flatProperties.kontakt_cbre.value)) {
        this.flatProperties.kontakt_cbre.value = this.flatProperties.kontakt_cbre.value.join(',');
      }
      for (let group in this.attributes) {
        this.attributes[group].forEach(attribute => {
          payload[attribute.name] = attribute.value;
        });
      }
      payload.geometria = this.selectedOffer.geometry;
      delete payload.geometria.properties;
      /*
      if(this.isNewEntity) {
        payload.geometria = this.newOffer.geometry;
      } else {
        payload.geometria = this.selectedOffer.geometry;
      }
      delete payload.geometria.properties;*/
      payload.id = this.entityID;
      return payload;
    },
    editOffer() {
      if (this.getIsFormValid()) {
        this.$store.dispatch('editOffer', this.preparePayload()).then(r => {
          if (r.status === 200) {
            this.$root.$emit('showSnackbar', this.$i18n.t('offer.offers.edit200'));
            this.attributesCopy = JSON.parse(JSON.stringify(this.flatProperties));
            this.isEdited = false;
            window.onbeforeunload = null;
            this.isReady = false;
            this.isReady = true;
          } else {
            this.$root.$emit('showSnackbar', this.$i18n.t('offer.offers.errorDB'));
          }
        });
      } else {
        this.$root.$emit('showSnackbar', this.$i18n.t('default.formErrors'));
      }
    },
    confirmExit() {
      this.$router.push(this.confirmExitTo);
    }
  },
  watch: {
    attributes: {
      handler() {
        this.isEdited = JSON.stringify(this.flatProperties) !== JSON.stringify(this.attributesCopy);
        if (this.isEdited) {
          window.onbeforeunload = () => {
            return '';
          };
        } else {
          window.onbeforeunload = null;
        }
      },
      deep: true
    }
  },
  mounted() {
    this.$root.$on('changeIsEdited', value => (this.isEdited = value));
    this.attributesCopy = {};
    this.dicts = DICTS;
    this.init();
  },
  created() {
    this.floatRule = v => /([0-9]+([.][0-9]+)?)/.test(v) || this.$i18n.t('default.mustBeNumber');
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEdited && !this.isConfirmExitVisible) {
      this.confirmExitTo = to;
      this.isConfirmExitVisible = true;
    } else {
      next();
    }
  },
  beforeDestroy() {
    window.onbeforeunload = null;
  }
};
</script>
<style lang="scss">
html {
  overflow: auto;
}
.expansion__panel--table {
  height: 300px;
}
.table {
  height: 100%;
}
.attributes {
  height: calc(100% - 65px);
  overflow-y: auto;
}
.invisible {
  display: none;
}
input:invalid {
  border: 1px solid #ff0000;
}
div.v-data-table__wrapper.vb-content {
  height: inherit !important;
}
.table__row--tools {
  text-align: center;
}
// th .v-icon {
//   display: none;
// }
#table-offers > div.v-data-table__wrapper.vb-content > table > thead > tr > th.text-center {
  display: flex;
  justify-content: center;
  align-items: self-start;
  box-shadow: none;
}
::-webkit-scrollbar {
  width: 7px;
}
::-webkit-scrollbar:hover ::-webkit-scrollbar {
  width: 12px;
}
::-webkit-scrollbar-thumb {
  background-color: rgba($primary-color, 0.3);
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: rgba($primary-color, 0.5);
  width: 12px;
}
.btn--add {
  position: absolute;
  right: 12px;
  top: 12px;
}
.btn--phone {
  position: absolute;
  right: 60px;
  top: 12px;
}
</style>
